// extracted by mini-css-extract-plugin
export default {"address":"_96sBc","field":"J0Kbn"};